// extracted by mini-css-extract-plugin
export var chevron = "_47-d";
export var disabled = "_47-b";
export var error = "_47-c";
export var hideBorder = "_47-1";
export var icon = "_47-e";
export var input = "_47-0";
export var large = "_47-f";
export var open = "_47-9";
export var placeholder = "_47-a";
export var regular = "_47-5";
export var singleRowInput = "_47-2";
export var singleSelectInput = "_47-3 _47-0";
export var small = "_47-4";
export var spinnerContainer = "_47-i";
export var tag = "_47-7";
export var tagsContainer = "_47-8";
export var tagsInput = "_47-6 _47-0";
export var xSmall = "_47-g";
export var xxSmall = "_47-h";